const initializeCollapsibleFilter = (rootElement: HTMLElement) => {
  const button = rootElement.querySelector<HTMLElement>(
    "[data-collapsible-filters-button]"
  );

  const collapsible = rootElement.querySelector<HTMLElement>("[data-collapsible]");
  const collapsibleInner = rootElement.querySelector<HTMLElement>(
    "[data-collapsible-inner]"
  );

  if (!button) {
    throw "Collapsible filters button missing";
  }

  if (!collapsible || !collapsibleInner) {
    throw "Collapsible filters collapsible missing";
  }

  // For desktop, disable the collapsible that shows/hides filters in mobile
  const enableShowFiltersCollapsible = () => {
    collapsible.style.overflow = "hidden";
  };

  const disableShowFiltersCollapsible = () => {
    collapsible.ariaHidden = "false";
    collapsible.style.overflow = "visible";
    collapsible.style.height = "auto";
    collapsibleInner.inert = false;
  };

  if (window.innerWidth > 1024) {
    disableShowFiltersCollapsible();
  }

  window.addEventListener("resize", () => {
    if (window.innerWidth > 1024) {
      disableShowFiltersCollapsible();
    } else {
      enableShowFiltersCollapsible();
    }
  });

  // Animate collapsible chevron
  collapsible.addEventListener("ani:toggle", _ => {
    const className = "[&_.chevron]:rotate-180";

    button.classList.toggle(className);
  });
};

document
  .querySelectorAll<HTMLElement>("[data-collapsible-filters]")
  .forEach(initializeCollapsibleFilter);
